import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {Router} from '@angular/router';
import {MenuService} from '../../../services/menu.service';
import {ModuleService} from '../../../services/module.service';
import {PermissionService} from '../../../services/permission.service';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-submenu-edit',
  templateUrl: './submenu-edit.component.html',
  styleUrls: ['./submenu-edit.component.scss']
})
export class SubmenuEditComponent implements OnInit{

  menuForm: FormGroup;
  modules: any[] = [];
  parents: any[] = [];
  permissions: any[] = [];

  public types: any[] = [
    {id: 1, name: 'link', title: 'submenu'},
  ];
  moduleSelected: number | undefined;
  typeSelected: string | undefined;
  parentSelected: number | undefined;

  parentsFiltered: any[] = [];

  permissionsSelected: any[] = [];

  saving = false;
  savingAndNew = false;
  childExist = '';

  waitingModule = false;
  waitingParent = false;
  loading = 'Loading...';


  public data: any;

  isSubmitted = false;
  val: any | null;
  update = this.translate.instant('Update');
  create = this.translate.instant('Save');

  @ViewChild(DatatableComponent) table: DatatableComponent;
  changeDetectorRefs: ChangeDetectorRef[] = [];

  constructor(private fb: FormBuilder,
              private menuService: MenuService,
              private moduleService: ModuleService,
              private permissionService: PermissionService,
              private translate: TranslateService,
              private toastr: ToastrService,
              public activeModal: NgbActiveModal,
              public route: Router
  ) {
    this.menuForm = this.fb.group({
      name: ['', [Validators.required, Validators.minLength(3)]],
      path: [''],
      type: ['', [Validators.required]],
      module: ['', [Validators.required]],
      parent: ['', [Validators.required]],
      position: [''],
      permissions: [''],
      isEnable: '',
    });

  }

  ngOnInit(): void {
    this.menuForm.get('isEnable')?.setValue('1');
    this.waitingModule = true;
    this.waitingParent = true;
    this.menuForm.patchValue(this.data);
    console.log(this.data);

    this.moduleSelected = this.data.module['@id'];
    console.log(this.data.parent);
    this.parentSelected = this.data.parent ? this.data.parent['@id'] : null;
    this.menuForm.get('isEnable')?.setValue(this.data.isEnable ? '1' : '0');
    // this.typeSelected = this.data.type;
    this.typeSelected = 'link'


    this.permissionsSelected = this.data.permissions.map((c: any) => c['@id']);

    console.log(this.permissionsSelected);

    this.findAllModule();
    this.findAllPermissions();
    //this.findAllMenu();

  }

  get fc(): any {
    return this.menuForm.controls;
  }

  onFormSubmit(): void{
    this.isSubmitted = true;
    if (this.menuForm.valid){
      this.saving = true;
      if (this.data){
        this.menuForm.get('isEnable')?.setValue(this.menuForm.get('isEnable')?.value === '1');
        this.menuService.putSubMenu(this.data.id, this.menuForm.value).subscribe({
          next: (val: any) => {
            this.toastr.success('Menu edit with success !', 'Success');
            this.activeModal.close();
          },
          complete: () => {
            this.saving = false;
            this.savingAndNew = false;
          },
          error: (err: any) =>
          {
            console.log(err);
            // const errors: any[] = err.error.violations;
            const errors: any[] = err.violations;

            if (errors){
              errors.forEach((v) =>
              {
                if (v.propertyPath === 'type'){
                  this.menuForm.get('category')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'module'){
                  this.menuForm.get('module')?.setErrors({serverError: v.message});
                }
                console.log(v.message);
                if (v.propertyPath === 'name'){
                  this.menuForm.get('name')?.setErrors({serverError: v.message});
                }
                if (v.propertyPath === 'position'){
                  this.menuForm.get('position')?.setErrors({serverError: v.message});
                }

                this.saving = false;
                this.savingAndNew = false;

              });
            }
            else {
              this.saving = false;
              this.savingAndNew = false;
              this.toastr.error(err['hydra:title'], 'Error');
            }

          }
        });
      }


    }
  }

  findAllModule() {
    this.moduleService.getEnableCollection().subscribe({
      next: (data: any) => {
        console.log(data['hydra:member']);
        this.modules = data['hydra:member'];
        if (this.modules){
          this.modules = this.modules.map((v) => {
            v.id = v['@id'];
            return v;
          });
          this.waitingModule = false;
        }
      },
      complete: () => this.findAllParent(),
      error: (error: HttpErrorResponse) => {
        this.findAllParent()
        console.log(error);
      }
    });
  }

  applyModuleFilter(event: any): void{
    console.log('BJR');
    // this.childrensFiltered = this.childrens.filter((childrens: any) => childrens.module['@id'] === this.moduleSelected);
    this.parentsFiltered = this.parents.filter((parents: any) => parents.module === this.moduleSelected);
  }

  findAllParent(): any{
    this.menuService.getCollectionParent().subscribe((data: any) => {
          this.parents = data['hydra:member'];
          this.parents = this.parents.map((v) => {
            //v.id = v['@id'];
            console.log(v['@id']);
            return v;
          });

          this.parentsFiltered = this.parents.filter((parents: any) => parents.module === this.moduleSelected);
          // console.log(this.parents)

          this.waitingParent = false;

        },
        error => console.log(error)
    );
  }

  findAllPermissions(): any{
    console.log(this.data.permissions);
    this.permissionService.getEnableCollection().subscribe((data: any) => {
          this.permissions = data['hydra:member'];
          console.log(this.permissions);
          this.permissions = this.permissions.map((v) => {
            v.id = v['@id'];
            v.name = v['name'];
            console.log(v['@id']);
            return v;
          });


        },
        error => console.log(error)
    );
  }


}
